import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, IconButton } from '@material-ui/core';
import BasicButton from 'Components/common/BasicButton';
import { ArrowBackIos } from '@material-ui/icons';
import { syncST } from 'Actions/userCenter';
import { syncWebAccount } from 'Actions/userCenter';
import { openNotification } from 'Actions/notification';
import Input from 'Components/common/Input';
import Dialog from 'Components/common/Dialog';
import { T } from 'Actions/translate';

class SyncST extends Component {

	state = {
		ST: '',
		StInfor: '',
		isST: false,
		isOpen: false,
		loading: false,
        userName: '',
        isUserNameValid:false,
        syncWebAccountLoading:false
	}

	handleChange = (name, value) => {
		const regPos = /^[0-9]+$/;
		const isST = regPos.test(value.trim());

		this.setState({ 
			isST: isST,
			[name]: value
		});
	};

	closeDialog = (name) => {
		if (this.state[name]) {
			this.setState({
				ST: '',
				StInfor: '',
				isST: false,
				[name]: false,
				loading: false,
			})
		}
	}

	submitSync = () => {
		const params = {};
		params.shipToNum =  this.state.ST;

		this.setState({
			loading: true,
		});

		this.props.syncST(params).then(res => {
			this.setState({
				StInfor: res.data,
				isOpen: true,
				loading: false,
			});
		}).catch(err => {
			this.setState({
				StInfor: '',
				isST: true,
				isOpen: false,
				loading: false
			});

			if(err.status === 'no_content') {
				this.props.openNotification(T('user_center_sync_no_content'), 'danger');
			} else {
				this.props.openNotification(T('user_center_sync_failed'), 'danger');
			}
		})
	}
    webAccountHandleChange = (name, value) => {
        const isUserNameValid = value.trim()===''?false:true;

        this.setState({
            isUserNameValid: isUserNameValid,
            [name]: value
        });
    };

    submitWebAccountSync = () => {
        const params = {};
        params.userName =  this.state.userName;

        this.setState({
            syncWebAccountLoading: true,
        });

        this.props.syncWebAccount(params).then(res => {
            this.setState({
                syncWebAccountLoading: false,
            });
            if (res && res.status ===  'success') {
                this.props.openNotification(T('user_center_sync_success'), 'success');
            }
        }).catch(err => {
            this.setState({
                isUserNameValid: true,
                syncWebAccountLoading: false
            });

            if(err.status === 'NOT_FOUND') {
                this.props.openNotification(T('user_center_sync_no_content'), 'danger');
            } else {
                this.props.openNotification(T('user_center_sync_failed'), 'danger');
            }
        })
    }

	render() {
		const { isST, isOpen, ST, StInfor, loading,userName,isUserNameValid,syncWebAccountLoading } = this.state;

		return (
			<div className='sync-st'>
				<Grid className='container-max-width is-fixed ship-to-head' container spacing={0} justify={'space-evenly'}>
					<Grid className='back-icon' item xs={3}>
						<IconButton color='inherit' onClick={() => this.props.history.push('/userCenter')}>
							<ArrowBackIos/>
						</IconButton>
					</Grid>

					<Grid className="page-title" item xs={9}>
						<span>{T('user_center_account_sync')}</span>
					</Grid>
				</Grid>



				<div className="content">
					<section className="content-box">
						<span className='order-report-title'>{T('user_center_account_sync_ST')}</span>
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<div className="row">
									<label>{T('ST')}</label>
									<Input type="text" 
										value={ST} 
										title="ST" 
										onChange={this.handleChange} 
										placeholder={T('user_center_enter_sync_ST')}/>
								</div>
							</Grid>
						</Grid>
					</section>
				</div>

				<Grid className='confirm-select' container spacing={0} justify={'center'}>
					<Grid item xs={4}>
						<BasicButton className='btn-width' type="primary" loading={loading} disabled={ isST ? false : true } onClickOfSingleTap={this.submitSync}>
							<span>{T('user_center_sync')}</span>
						</BasicButton>
					</Grid>
				</Grid>

				<Dialog dialogDidClose={()=>this.closeDialog('isOpen')} opened={isOpen} options={{ bgClickClose: true }}>
					<div className='logout-dialog'>
						<Grid className='dialog-title' container spacing={0}>
							<Grid item xs={12}>
								<span>{T('user_center_sync_success')}</span>
							</Grid>
						</Grid>

						<Grid className='dialog-content' container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<span>{StInfor.st}</span>
							</Grid>
							<Grid item xs={12}>
								<span>{StInfor.stAlpha}</span>
							</Grid>
						</Grid>

						<Grid container spacing={0}>
							<Grid item xs={12} align="center">
								<BasicButton className="confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.closeDialog('isOpen')}>
									<span>{T('getInfo')}</span>
								</BasicButton>
							</Grid>
						</Grid>
					</div>
				</Dialog>

				<div className="content" style={{marginTop:"2rem"}}>
					<section className="content-box">
						<span className='order-report-title'>{T('user_center_account_sync_online')}</span>
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<div className="row">
									<label>{T('user_center_sync_login_name')}</label>
									<Input type="text"
										   value={userName}
										   title="userName"
										   onChange={this.webAccountHandleChange}
										   placeholder={T('user_center_enter_sync_online')}/>
								</div>
							</Grid>
						</Grid>
					</section>
				</div>

				<Grid className='confirm-select' container spacing={0} justify={'center'}>
					<Grid item xs={4}>
						<BasicButton className='btn-width' type="primary" loading={syncWebAccountLoading} disabled={ isUserNameValid ? false : true } onClickOfSingleTap={this.submitWebAccountSync}>
							<span>{T('user_center_sync')}</span>
						</BasicButton>
					</Grid>
				</Grid>

			</div>
		);
	}
}

const mapStateToProps = state => {
	const { userCenter } = state;
	return {
		syncST: userCenter.syncST,
        syncWebAccount:userCenter.syncWebAccount
	};
};

const mapDispatchToProps = {
	syncST,
    syncWebAccount,
	openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncST);
